<!--
  ~ Copyright (C) 2018 Robert Bosch GmbH Copyright (C) 2018 Robert Bosch Manufacturing Solutions GmbH, Germany. All rights reserved.
  -->

<div class="dialog-header">
  <h3>
    <ng-container [ngSwitch]="data.type">
      <mat-icon
        *ngSwitchCase="AlertType.Warning"
        class="warning-icon"
        fontIcon="bosch-ic-alert-warning-filled"
      ></mat-icon>
      <mat-icon
        *ngSwitchCase="AlertType.Error"
        class="error-icon"
        fontIcon="bosch-ic-alert-error-filled"
      ></mat-icon>
    </ng-container>
    <span>{{ data.title }}</span>
  </h3>
  <button
    (click)="close(AlertClosingType.CloseButton)"
    class="close-button"
    mat-icon-button
  >
    <i class="bosch-ic bosch-ic-clickable bosch-ic-close"></i>
  </button>
</div>
<mat-dialog-content>{{ data.description }}</mat-dialog-content>
<mat-dialog-actions>
  <!-- Outer Left Button -->
  <button
    (click)="close(AlertClosingType.OuterLeftButton)"
    *ngIf="
      data.outerLeftButtonTitle &&
      data.primaryButton != PrimaryButton.OuterLeftButton
    "
    [disabled]="data.outerLeftButtonDisabled"
    class="alert-outer-left-btn"
    mat-button
    type="button"
  >
    {{ data.outerLeftButtonTitle }}
  </button>
  <button
    #outerLeftBtnRaised
    (click)="close(AlertClosingType.OuterLeftButton)"
    *ngIf="
      data.outerLeftButtonTitle &&
      data.primaryButton === PrimaryButton.OuterLeftButton
    "
    [disabled]="data.outerLeftButtonDisabled"
    class="alert-outer-left-btn"
    mat-raised-button
    color="primary"
    type="button"
  >
    {{ data.outerLeftButtonTitle }}
  </button>

  <!-- Left Button -->
  <button
    (click)="close(AlertClosingType.LeftButton)"
    *ngIf="
      data.leftButtonTitle && data.primaryButton != PrimaryButton.LeftButton
    "
    [disabled]="data.leftButtonDisabled"
    class="alert-left-btn"
    mat-button
    type="button"
  >
    {{ data.leftButtonTitle }}
  </button>
  <button
    #leftBtnRaised
    (click)="close(AlertClosingType.LeftButton)"
    *ngIf="
      data.leftButtonTitle && data.primaryButton === PrimaryButton.LeftButton
    "
    [disabled]="data.leftButtonDisabled"
    class="alert-left-btn"
    mat-raised-button
    color="primary"
    type="button"
  >
    {{ data.leftButtonTitle }}
  </button>

  <!-- Right Button -->
  <button
    #rightBtn
    (click)="close(AlertClosingType.RightButton)"
    *ngIf="
      data.rightButtonTitle && data.primaryButton != PrimaryButton.RightButton
    "
    [disabled]="data.rightButtonDisabled"
    class="alert-right-btn"
    mat-button
    type="button"
  >
    {{ data.rightButtonTitle }}
  </button>
  <button
    #rightBtnRaised
    (click)="close(AlertClosingType.RightButton)"
    *ngIf="
      data.rightButtonTitle && data.primaryButton === PrimaryButton.RightButton
    "
    [disabled]="data.rightButtonDisabled"
    class="alert-right-btn"
    mat-raised-button
    color="primary"
    type="button"
  >
    {{ data.rightButtonTitle }}
  </button>
</mat-dialog-actions>
